import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'

import Chip from '../Chip'

library.add(faUserPlus)

interface ShareWorldProps {
  active?: boolean
  onClick?: () => void
}

const BoxIcon = () => (
  <span className="flex justify-center items-center bg-gray-200 w-10 h-10 min-w-10 rounded-lg">
    <FontAwesomeIcon
      className="text-lg text-gray-500"
      icon={['fas', 'user-plus']}
    />
  </span>
)

const ShareNeedRegistration = ({ active, onClick }: ShareWorldProps) => {
  return (
    <Chip
      icon={<BoxIcon />}
      highlight
      highlightCustomClass="p-3 flex-col gap-y-3 sm:flex-1"
      active={active}
      onClick={onClick}
    >
      <span className="flex flex-col gap-y-1">
        <Title size="2XS">
          <Trans>Richiedi registrazione</Trans>
        </Title>
        <Paragraph className="text-gray-500 sm:max-w-sm sm:w-auto">
          <Trans>
            Condividi contenuti richiedendo la registrazione per accedere.
            Proteggi i tuoi materiali, scopri chi li guarda e acquisisci lead.
          </Trans>
        </Paragraph>
      </span>
    </Chip>
  )
}

export default ShareNeedRegistration
